/* tslint:disable */
/* eslint-disable */
/**
 * orderstatus/order_status.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from './base';

/**
 *
 * @export
 * @interface OrderStatusGetV1ResponseCustomizeItem
 */
export interface OrderStatusGetV1ResponseCustomizeItem {
  /**
   *
   * @type {number}
   * @memberof OrderStatusGetV1ResponseCustomizeItem
   */
  quantity?: number;
  /**
   *
   * @type {OrderstatusLanguages}
   * @memberof OrderStatusGetV1ResponseCustomizeItem
   */
  name?: OrderstatusLanguages;
}
/**
 *
 * @export
 * @interface OrderStatusGetV1ResponseOrderItem
 */
export interface OrderStatusGetV1ResponseOrderItem {
  /**
   *
   * @type {number}
   * @memberof OrderStatusGetV1ResponseOrderItem
   */
  quantity?: number;
  /**
   *
   * @type {OrderstatusLanguages}
   * @memberof OrderStatusGetV1ResponseOrderItem
   */
  name?: OrderstatusLanguages;
  /**
   *
   * @type {Array<OrderStatusGetV1ResponseCustomizeItem>}
   * @memberof OrderStatusGetV1ResponseOrderItem
   */
  customizeItems?: Array<OrderStatusGetV1ResponseCustomizeItem>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const OrderStatusGetV1ResponseOrderStatus = {
  Prepared: 'PREPARED',
  Ready: 'READY',
  Delivered: 'DELIVERED',
  Cancelled: 'CANCELLED',
  NotFound: 'NOT_FOUND',
} as const;

export type OrderStatusGetV1ResponseOrderStatus =
  (typeof OrderStatusGetV1ResponseOrderStatus)[keyof typeof OrderStatusGetV1ResponseOrderStatus];

/**
 *
 * @export
 * @interface OrderstatusLanguage
 */
export interface OrderstatusLanguage {
  /**
   *
   * @type {string}
   * @memberof OrderstatusLanguage
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof OrderstatusLanguage
   */
  text?: string;
}
/**
 *
 * @export
 * @interface OrderstatusLanguages
 */
export interface OrderstatusLanguages {
  /**
   *
   * @type {Array<OrderstatusLanguage>}
   * @memberof OrderstatusLanguages
   */
  languages?: Array<OrderstatusLanguage>;
}
/**
 *
 * @export
 * @interface OrderstatusOrderStatusGetV1Response
 */
export interface OrderstatusOrderStatusGetV1Response {
  /**
   *
   * @type {string}
   * @memberof OrderstatusOrderStatusGetV1Response
   */
  orderedLanguage?: string;
  /**
   *
   * @type {OrderStatusGetV1ResponseOrderStatus}
   * @memberof OrderstatusOrderStatusGetV1Response
   */
  status?: OrderStatusGetV1ResponseOrderStatus;
  /**
   *
   * @type {string}
   * @memberof OrderstatusOrderStatusGetV1Response
   */
  oderNo?: string;
  /**
   *
   * @type {OrderstatusLanguages}
   * @memberof OrderstatusOrderStatusGetV1Response
   */
  restaurantName?: OrderstatusLanguages;
  /**
   *
   * @type {Array<OrderStatusGetV1ResponseOrderItem>}
   * @memberof OrderstatusOrderStatusGetV1Response
   */
  orderItems?: Array<OrderStatusGetV1ResponseOrderItem>;
}

/**
 *
 * @export
 * @interface ProtobufAny
 */
export interface ProtobufAny {
  [key: string]: object | any;

  /**
   *
   * @type {string}
   * @memberof ProtobufAny
   */
  '@type'?: string;
}
/**
 *
 * @export
 * @interface RpcStatus
 */
export interface RpcStatus {
  /**
   *
   * @type {number}
   * @memberof RpcStatus
   */
  code?: number;
  /**
   *
   * @type {string}
   * @memberof RpcStatus
   */
  message?: string;
  /**
   *
   * @type {Array<ProtobufAny>}
   * @memberof RpcStatus
   */
  details?: Array<ProtobufAny>;
}

/**
 * OrderStatusServiceApi - axios parameter creator
 * @export
 */
export const OrderStatusServiceApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {string} restaurantId
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderStatusServiceOrderStatusGetV1: async (
      restaurantId: string,
      orderId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'restaurantId' is not null or undefined
      assertParamExists(
        'orderStatusServiceOrderStatusGetV1',
        'restaurantId',
        restaurantId,
      );
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists(
        'orderStatusServiceOrderStatusGetV1',
        'orderId',
        orderId,
      );
      const localVarPath =
        `/v1/instore_kiosk/oder_status/{restaurantId}/{orderId}`
          .replace(
            `{${'restaurantId'}}`,
            encodeURIComponent(String(restaurantId)),
          )
          .replace(`{${'orderId'}}`, encodeURIComponent(String(orderId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OrderStatusServiceApi - functional programming interface
 * @export
 */
export const OrderStatusServiceApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    OrderStatusServiceApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} restaurantId
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orderStatusServiceOrderStatusGetV1(
      restaurantId: string,
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OrderstatusOrderStatusGetV1Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.orderStatusServiceOrderStatusGetV1(
          restaurantId,
          orderId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'OrderStatusServiceApi.orderStatusServiceOrderStatusGetV1'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * OrderStatusServiceApi - factory interface
 * @export
 */
export const OrderStatusServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = OrderStatusServiceApiFp(configuration);
  return {
    /**
     *
     * @param {string} restaurantId
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderStatusServiceOrderStatusGetV1(
      restaurantId: string,
      orderId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderstatusOrderStatusGetV1Response> {
      return localVarFp
        .orderStatusServiceOrderStatusGetV1(restaurantId, orderId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * OrderStatusServiceApi - object-oriented interface
 * @export
 * @class OrderStatusServiceApi
 * @extends {BaseAPI}
 */
export class OrderStatusServiceApi extends BaseAPI {
  /**
   *
   * @param {string} restaurantId
   * @param {string} orderId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderStatusServiceApi
   */
  public orderStatusServiceOrderStatusGetV1(
    restaurantId: string,
    orderId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return OrderStatusServiceApiFp(this.configuration)
      .orderStatusServiceOrderStatusGetV1(restaurantId, orderId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
